import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ProjectChatAgentRun({ run, locked, hasFeedback, working, onRetry }) {
  const { t } = useTranslation();
  if (!run || (run.status === 'investigated' && !working)) return null;
  const stopped = !working && ['blocked', 'stopped'].includes(run.status);
  return <Alert severity={stopped ? 'warning' : 'info'}>
    <Stack spacing={1}>
      <Typography variant="subtitle2">{t(stopped ? 'project_chat.agent.paused' : 'project_chat.agent.working')}</Typography>
      <Typography variant="body2">{t('project_chat.agent.last_step')}: {t(`project_chat.agent.actions.${run.last_action}`)}</Typography>
      {stopped && <>
        <Typography variant="body2">{t(`project_chat.codes.${run.blocker}`, t('project_chat.codes.agent_unavailable'))}</Typography>
        <Typography variant="body2">{t('project_chat.agent.next')}</Typography>
        {hasFeedback && <Typography variant="caption">{t('project_chat.agent.draft_hint')}</Typography>}
        {run.original_message?.trim() && !['safety_blocked', 'access_denied'].includes(run.blocker) &&
          <Button disabled={locked || hasFeedback} onClick={() => onRetry(run.original_message)}>
          {t('project_chat.agent.retry')}
        </Button>}
      </>}
    </Stack>
  </Alert>;
}
